/**
 * @author xyguo
 * @description 新开业培训要求记录管理
 * @Date 2021/3/16
 */
import React from 'react';
import { connect } from 'dva';
import { templateConfig, reduxTemplateCofig } from './config'

import { framework_tool,component_tool,utils_tool } from '@/tool'
let { WizContainer, WizReduxTemplate } = framework_tool;
let { WizBrowserExport,WizCard,WizTabs,WizSpin} = component_tool;
let {checkStrLength,Session} = utils_tool;
class RequirementRecord extends WizContainer {

  componentName = 'RequirementRecord';

  constructor(props) {
    super(props);
    this.state = {
    }
    this.initialValue = {};
    const {history} = props;
    if (history.location.record) {
      Session.set('requirementRecordInfo', history.location.record);
      this.initialValue = history.location.record;
    } else if (Session.get('requirementRecordInfo')) {
      this.initialValue = Session.get('requirementRecordInfo') ? Session.get('requirementRecordInfo') : {};
    }
  }

  _handleCMD(nextProps, nextState, key) {
    let o = nextProps[key]
    if (o['success']) {
      wizNotice.success(o['msg'])
      return true;
    } else {
      wizNotice.error(o['msg'])
      return false;
    }
  }

  _render() {
    let id = this.initialValue.id;
    let _reduxTemplateCofig = reduxTemplateCofig({
      id,
      templateConfig,
      apiDataFormat: {
        
      },
      keepInitApiParams: true,
    })
    return <WizReduxTemplate {..._reduxTemplateCofig} />
  }
}

const mapStateToProps = (state, ownProps) => {
  return {}
};

export default connect(mapStateToProps)(RequirementRecord);
